import axios from 'axios'
import useSWRImmutable from 'swr/immutable'

import { IRowsNColumns } from '@services/data-service'

const useRowsNColumns = (dataTableId: number) => {
  const fetcher = async url => (await axios.get(url)).data
  const { data: labels, error, mutate } = useSWRImmutable<IRowsNColumns>(
    () => (dataTableId != null ? `/api/data_tables/${dataTableId}/labels/` : null),
    fetcher
  )
  return {
    error: error || null,
    rows: labels?.rows || [],
    columns: labels?.columns || [],
    loading: dataTableId != null && !labels && !error,
    // `sum_values` actions add/remove real columns/rows in the table (issue #663). This entry
    // is immutable (no auto-revalidation), so callers must invoke this to refetch the label
    // list after such a change, otherwise Sort by / Reorder / etc. show a stale list.
    mutate
  }
}

export { useRowsNColumns }
